// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"131":"3b53517f","291":"3b53517f","967":"3b53517f","988":"3b53517f"}[chunkId] + ".chunk.css";
};